// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"e2d3ae45","281":"7168d05f","491":"af236a43","520":"b80f2e9d","685":"ce29df93","692":"67a816e4","918":"abd76be6"}[chunkId] + ".chunk.css";
};